import { FC } from "react";
import { CircularProgress } from "@mui/material";
import styled from "@emotion/styled";

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

const Loader: FC = () => {
  return (
    <Container>
      <CircularProgress />
    </Container>
  );
};

export default Loader;
